/**
 * Debug utility for checking currency and regional settings
 * This file provides console helper functions for debugging settings
 */

import { getCurrencySettings, formatCurrency } from './currencyFormatter';

/**
 * Check current currency settings
 * Call this in browser console: window.checkCurrencySettings()
 */
export const checkCurrencySettings = () => {
  console.log('='.repeat(80));
  console.log('🔍 CURRENCY SETTINGS DEBUG');
  console.log('='.repeat(80));
  
  // Check session storage
  console.log('\n📦 Session Storage:');
  const sessionSettings = sessionStorage.getItem('currency_settings');
  if (sessionSettings) {
    console.log('✅ Found currency_settings:', JSON.parse(sessionSettings));
  } else {
    console.log('❌ No currency_settings found in session storage');
  }
  
  const companySettings = sessionStorage.getItem('company_settings');
  if (companySettings) {
    console.log('✅ Found company_settings:', JSON.parse(companySettings));
  } else {
    console.log('❌ No company_settings found in session storage');
  }
  
  // Check global currency settings
  console.log('\n💱 Global Currency Settings:');
  const currentSettings = getCurrencySettings();
  console.log(currentSettings);
  
  // Test formatter
  console.log('\n🧪 Format Test:');
  console.log('formatCurrency(1000)    =', formatCurrency(1000));
  console.log('formatCurrency(1234.56) =', formatCurrency(1234.56));
  console.log('formatCurrency(999.99)  =', formatCurrency(999.99));
  
  // Check if settings are loaded
  console.log('\n⏰ Settings Loaded:');
  const timestamp = sessionStorage.getItem('settings_loaded_timestamp');
  if (timestamp) {
    const loadedDate = new Date(parseInt(timestamp));
    console.log('✅ Settings loaded at:', loadedDate.toLocaleString());
  } else {
    console.log('❌ Settings not loaded yet');
  }
  
  console.log('='.repeat(80));
};

/**
 * Force reload settings from backend
 */
export const reloadCurrencySettings = async () => {
  console.log('🔄 Reloading settings from backend...');
  
  try {
    const { reloadSettings } = await import('../services/settingsInitService');
    const result = await reloadSettings();
    
    if (result) {
      console.log('✅ Settings reloaded successfully');
      checkCurrencySettings();
    } else {
      console.log('❌ Failed to reload settings');
    }
  } catch (error) {
    console.error('❌ Error reloading settings:', error);
  }
};

/**
 * Clear all settings
 */
export const clearCurrencySettings = () => {
  console.log('🗑️  Clearing all settings...');
  
  sessionStorage.removeItem('currency_settings');
  sessionStorage.removeItem('company_settings');
  sessionStorage.removeItem('date_format');
  sessionStorage.removeItem('settings_loaded_timestamp');
  
  console.log('✅ Settings cleared. Please login again.');
};

// Make functions available in browser console
if (typeof window !== 'undefined') {
  window.checkCurrencySettings = checkCurrencySettings;
  window.reloadCurrencySettings = reloadCurrencySettings;
  window.clearCurrencySettings = clearCurrencySettings;
  
  console.log('🛠️  Currency Settings Debug Tools Loaded!');
  console.log('📝 Available commands:');
  console.log('   window.checkCurrencySettings()  - Check current settings');
  console.log('   window.reloadCurrencySettings() - Reload settings from backend');
  console.log('   window.clearCurrencySettings()  - Clear all settings');
}

export default {
  checkCurrencySettings,
  reloadCurrencySettings,
  clearCurrencySettings
};

